angular.module('zc.projects')

.directive 'zcTitleSelector', (ProjectTitleSelector, Meta, BaseProjectCrudEditor) ->

  class TitleSelector extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality

  editor = new TitleSelector(
    ProjectTitleSelector
    Meta
    '/templates/projects.settings/other/title_selector.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/title_selector.directive.coffee